import React, { useState, useEffect } from 'react';
import { listSavedCharts, getChartDetails } from '../services/horoscopeChartApi';
import '../styles/SavedCharts.css';

const SavedCharts = ({ onChartSelected, isLoading = false }) => {
  const [savedCharts, setSavedCharts] = useState([]);
  const [selectedChartId, setSelectedChartId] = useState('');
  const [loadingChart, setLoadingChart] = useState(false);
  const [error, setError] = useState('');
  const [loadingList, setLoadingList] = useState(true);

  // Load saved charts list on mount
  useEffect(() => {
    loadSavedChartsList();
  }, []);

  const loadSavedChartsList = async () => {
    setLoadingList(true);
    setError('');
    try {
      console.log('Loading saved charts from API...');
      const charts = await listSavedCharts();
      console.log('Received charts:', charts);
      setSavedCharts(charts);
      
      if (charts.length === 0) {
        console.log('No saved charts found');
        setError('No saved charts found. Generate a new chart and save it!');
      }
    } catch (err) {
      console.error('Error loading saved charts:', err);
      setError(err.message || 'Failed to load saved charts');
      setSavedCharts([]);
    } finally {
      setLoadingList(false);
    }
  };

  const handleChartSelect = async (chartId) => {
    setSelectedChartId(chartId);
    setLoadingChart(true);
    setError('');
    
    try {
      const chartData = await getChartDetails(chartId);
      onChartSelected(chartData);
    } catch (err) {
      setError(err.message || 'Failed to load chart details');
      setSelectedChartId('');
    } finally {
      setLoadingChart(false);
    }
  };

  return (
    <div className="saved-charts-container">
      <div className="saved-charts-header">
        <h3>📚 My Saved Charts</h3>
        <button 
          className="refresh-charts-btn" 
          onClick={loadSavedChartsList}
          disabled={loadingList || loadingChart}
          title="Refresh saved charts"
        >
          🔄 Refresh
        </button>
      </div>

      {loadingList ? (
        <div className="saved-charts-loading">
          <div className="spinner"></div>
          <p>Loading your saved charts...</p>
        </div>
      ) : error && savedCharts.length === 0 ? (
        <div className="saved-charts-empty">
          <p>⚠️ {error}</p>
        </div>
      ) : (
        <>
          <div className="saved-charts-dropdown-wrapper">
            <label htmlFor="saved-charts-select" className="saved-charts-label">
              Select a chart to view:
            </label>
            <select
              id="saved-charts-select"
              className="saved-charts-dropdown"
              value={selectedChartId}
              onChange={(e) => handleChartSelect(e.target.value)}
              disabled={loadingChart || savedCharts.length === 0}
            >
              <option value="">-- Choose a saved chart --</option>
              {savedCharts.map((chart) => (
                <option key={chart.chart_id} value={chart.chart_id}>
                  {chart.chart_name}
                </option>
              ))}
            </select>
          </div>

          {error && selectedChartId && (
            <div className="saved-charts-error">
              ⚠️ {error}
            </div>
          )}

          {loadingChart && (
            <div className="saved-charts-loading-details">
              <div className="spinner"></div>
              <p>Loading chart details...</p>
            </div>
          )}

          {selectedChartId && !loadingChart && (
            <div className="saved-charts-info">
              <p className="info-text">
                ✓ Chart loaded successfully! Scroll down to view the full chart.
              </p>
            </div>
          )}

          <div className="saved-charts-count">
            <small>{savedCharts.length} saved chart{savedCharts.length !== 1 ? 's' : ''}</small>
          </div>
        </>
      )}
    </div>
  );
};

export default SavedCharts;
